import React from 'react';

const Fcap = (props) => (
    <svg
        width="22px"
        height="22px"
        viewBox="0 0 22 22"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        {...props}
    >
        <title>Icon/FC b@1.5x</title>
        <g id="Gscope---Left-Navigation" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Gscope_icons" transform="translate(-388.000000, -1856.000000)" fill="#000000">
                <g id="Icon/FC-b" transform="translate(388.000000, 1856.000000)">
                    <path
                        d="M11.45,0.8375 L17,5 L20.75,5 C21.1642136,5 21.5,5.33578644 21.5,5.75 L21.5,21.5 L12.5,21.5 L12.5,16.25 L9.5,16.25 L9.5,21.5 L0.5,21.5 L0.5,5.75 C0.5,5.33578644 0.835786438,5 1.25,5 L5,5 L10.55,0.8375 C10.8166667,0.6375 11.1833333,0.6375 11.45,0.8375 Z M16.5,6.5 L11,2.375 L5.5,6.5 L2,6.5 L2,20 L8,20 L8,14.75 L14,14.75 L14,20 L20,20 L20,6.5 L16.5,6.5 Z"
                        id="🎨-Color"
                    ></path>
                </g>
            </g>
        </g>
    </svg>
);

export default Fcap;
